'use strict';

let config ={
    requestSubmitUrl: 'https://backend.ticketgroup-russia.com/application',
    //requestSubmitUrl: 'http://localhost:8080/application',
    russianBordersKmlUrl: 'http://ticketgroup.qnium.com/russianBorder.kml'
}

module.exports = config;
